import React, { useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import AIChatSheet from "./AIChatSheet";
import { Menu, X, MessageCircle } from "lucide-react";

export default function Layout({ children }) {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [chatOpen, setChatOpen] = useState(false);

    return (
        <div className="min-h-screen bg-[#F7F7F5]">
            {/* Top bar */}
            <header className="sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-gray-200">
                <div className="flex items-center justify-between px-4 lg:px-8 h-20">
                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => setMobileOpen(true)}
                            className="lg:hidden p-2 -ml-2 rounded-md hover:bg-gray-100"
                            aria-label="Open menu"
                            data-testid="open-mobile-menu"
                        >
                            <Menu className="h-5 w-5" />
                        </button>
                        <Link to="/" className="flex items-center gap-3" data-testid="home-link">
                            <img
                                src="/bscc-logo.png"
                                alt="Badenoch & Strathspey Community Connections"
                                className="h-12 sm:h-14 w-auto object-contain"
                            />
                            <div className="leading-tight border-l border-gray-200 pl-3 hidden md:block">
                                <div className="font-semibold text-[15px] text-gray-900" style={{ fontFamily: "Outfit" }}>Driver Handbook</div>
                                <div className="text-[11px] text-gray-500">Interactive edition</div>
                            </div>
                        </Link>
                    </div>
                    <div className="flex items-center gap-2">
                        <a
                            href="tel:01479810004"
                            className="hidden sm:inline-flex items-center gap-2 text-sm text-gray-700 hover:text-[#2C7A85] px-3 py-2"
                            data-testid="header-office-phone"
                        >
                            Office: <span className="font-medium">01479 810004</span>
                        </a>
                        <button
                            onClick={() => setChatOpen(true)}
                            className="inline-flex items-center gap-2 bg-[#2C7A85] hover:bg-[#1F5F69] text-white text-sm px-3 sm:px-4 py-2 rounded-md transition-colors"
                            data-testid="open-ai-chat"
                        >
                            <MessageCircle className="h-4 w-4" />
                            <span className="hidden sm:inline">Ask the Handbook</span>
                            <span className="sm:hidden">AI</span>
                        </button>
                    </div>
                </div>
            </header>

            <div className="flex">
                {/* Desktop sidebar */}
                <div className="hidden lg:block w-72 xl:w-80 flex-shrink-0 border-r border-gray-200 bg-[#F7F7F5] h-[calc(100vh-5rem)] sticky top-20">
                    <Sidebar />
                </div>

                {/* Main content */}
                <main className="flex-1 min-w-0">
                    {children}
                </main>
            </div>

            {/* Mobile sidebar overlay */}
            {mobileOpen && (
                <div className="fixed inset-0 z-40 lg:hidden">
                    <div className="absolute inset-0 bg-black/40" onClick={() => setMobileOpen(false)} />
                    <div className="absolute inset-y-0 left-0 w-80 max-w-[85%] bg-white shadow-xl flex flex-col">
                        <div className="flex items-center justify-between h-20 px-4 border-b border-gray-200">
                            <div className="font-semibold" style={{ fontFamily: "Outfit" }}>Contents</div>
                            <button onClick={() => setMobileOpen(false)} className="p-2 -mr-2 rounded-md hover:bg-gray-100" aria-label="Close menu" data-testid="close-mobile-menu">
                                <X className="h-5 w-5" />
                            </button>
                        </div>
                        <div className="flex-1 overflow-y-auto">
                            <Sidebar onNavigate={() => setMobileOpen(false)} />
                        </div>
                    </div>
                </div>
            )}

            {/* Floating chat */}
            <button
                onClick={() => setChatOpen(true)}
                className="fixed bottom-6 right-6 z-30 lg:hidden h-14 w-14 rounded-full bg-[#2C7A85] hover:bg-[#1F5F69] text-white shadow-lg grid place-items-center"
                aria-label="Ask the Handbook AI"
                data-testid="floating-ai-button"
            >
                <MessageCircle className="h-6 w-6" />
            </button>

            <AIChatSheet open={chatOpen} onClose={() => setChatOpen(false)} />
        </div>
    );
}
